// nodejs library to set properties for components
import PropTypes from "prop-types";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";

import { getImage } from "assets/Images";

export default function FullPageImage({ bgImage, child }) {
	return (
		<MDBox
			position="relative"
			display="flex"
			alignItems="center"
			justifyContent="center"
			width="100%"
			minHeight="100vh"
			py="120px"
			color="white"
			sx={{
				backgroundImage: `url(${getImage(bgImage)})`,
				backgroundSize: "cover",
				backgroundPosition: "center center"
			}}
		>
			{child}
		</MDBox>
	);
}

FullPageImage.propTypes = {
	bgImage: PropTypes.string.isRequired,
	child: PropTypes.node
};
